module.exports = __webpack_public_path__ + "media/assets/consultation/budget_35000-d4d674223a4421cefc6de37d54f98030.svg";